import { useSelector } from 'react-redux';
import type { AuthState } from './types';

type RootWithAuth = { auth: AuthState };

export function useAuth() {
  const { user, session, role, permissions } = useSelector((s: RootWithAuth) => s.auth);
  const perms = permissions ?? [];
  return {
    user,
    session,
    role: role ?? '',
    permissions: perms,
    isAuthenticated: Boolean(session?.token),
    /** True if the user may perform `code` (or holds the `*` wildcard). */
    can: (code: string) => perms.includes('*') || perms.includes(code)
  };
}
